export class TeoAssertionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DevAssertionError';
  }
}

export function devAssert(condition: boolean, msg: string): condition is true {
  if (!condition) {
    if (__DEV__) {
      throw new TeoAssertionError(msg);
    }
    console.warn(`Assertion failed: ${msg}`);
  }
  return condition;
}

export function devAssertNonNullable<T>(condition: T, msg: string): condition is NonNullable<T> {
  if (condition === null || condition === undefined) {
    if (__DEV__) {
      throw new TeoAssertionError(msg);
    }
    console.warn(`Assertion failed: ${msg}`);
    return false;
  }
  return true;
}
